import purpleBtn from "@assets/imgs/btns/purple-btn.png";
import purpleDarkBtn from "@assets/imgs/btns/purple-dark-btn.png";
import { AudioManager } from "@/phaser/core/audio/AudioManager";
import { BaseButton } from "@phaser/ui/btns/BaseButton";

interface PurpleBtnOptions {
  disabled?: boolean;
  selected?: boolean;
  coinAmount?: number;
}

export class PurpleBtn extends BaseButton {
  private bg: Phaser.GameObjects.Image;
  private label?: Phaser.GameObjects.Text;
  private coinIcon?: Phaser.GameObjects.Image;
  private coinValueText?: Phaser.GameObjects.Text;

  private readonly normalColor = "#FFFFFF";
  private readonly activeColor = "#471396";

  private isDisabled = false;
  private isSelected = false;

  static preload(scene: Phaser.Scene) {
    scene.load.image("purple-btn", purpleBtn);
    scene.load.image("purple-dark-btn", purpleDarkBtn);
  }

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    text: string,
    onClick: () => void,
    options?: PurpleBtnOptions,
  ) {
    super(scene, x, y, {
      onClick,
      sfx: () => AudioManager.playSfx("sfx-button"),
      onPress: () => {
        if (this.isDisabled) return;
        this.setPressedStyle();
      },
      onRelease: () => {
        if (this.isDisabled) return;
        this.resetButton();
      },
    });

    this.isSelected = options?.selected ?? false;

    this.bg = scene.add
      .image(0, 0, this.isSelected ? "purple-dark-btn" : "purple-btn")
      .setOrigin(0.5);

    this.add(this.bg);

    const coinAmount = options?.coinAmount;

    if (coinAmount !== undefined) {
      this.coinIcon = scene.add.image(-85, 0, "coin-icon").setOrigin(0.5);
      this.coinIcon.setDisplaySize(48, 48);

      this.coinValueText = scene.add
        .text(105, -2, coinAmount.toLocaleString(), {
          fontFamily: "Black Han Sans",
          fontSize: "30px",
          color: "#FFD93D",
        })
        .setOrigin(1, 0.5);

      this.add([this.coinIcon, this.coinValueText]);
    } else {
      this.label = scene.add
        .text(0, -2, text, {
          fontFamily: "Black Han Sans",
          fontSize: "36px",
          color: this.normalColor,
        })
        .setOrigin(0.5);

      this.add(this.label);
    }

    this.enableButton(this.bg.width, this.bg.height);

    this.isDisabled = options?.disabled ?? false;

    if (this.isDisabled) {
      this.setDisabledState();
      this.disableInteractive();
    }

    scene.add.existing(this);
  }

  setSelected(selected: boolean) {
    this.isSelected = selected;

    this.bg.setTexture(selected ? "purple-dark-btn" : "purple-btn");
  }

  private setPressedStyle() {
    this.setScale(0.9);
  }

  private setDisabledState() {
    this.setScale(1);
    this.label?.setColor(this.activeColor);
  }

  private resetButton() {
    this.setScale(1);
  }
}
